import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

function Navbar() {
  const { user, isAuthenticated, isAdmin, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">R</span>
          <span className="logo-text">ReDoIt</span>
        </Link>

        <button
          className="navbar-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
          <div className="navbar-links">
            {isAuthenticated ? (
              <>
                <Link to="/dashboard" className="navbar-link">
                  Dashboard
                </Link>
                <Link to="/generate" className="navbar-link">
                  Generate
                </Link>
                <Link to="/gallery" className="navbar-link">
                  Gallery
                </Link>
                <Link to="/pricing" className="navbar-link">
                  Pricing
                </Link>
                {isAdmin && (
                  <Link to="/admin" className="navbar-link admin-link">
                    Admin
                  </Link>
                )}
              </>
            ) : (
              <>
                <Link to="/pricing" className="navbar-link">
                  Pricing
                </Link>
              </>
            )}
          </div>

          <div className="navbar-actions">
            {isAuthenticated ? (
              <div className="navbar-user">
                <div className="credits-badge">
                  <span className="credits-icon">C</span>
                  <span>{user?.credits?.toFixed(0) || 0}</span>
                </div>
                <div className="user-menu">
                  <button className="user-button">
                    {user?.picture ? (
                      <img
                        src={user.picture}
                        alt={user.name}
                        className="user-avatar"
                      />
                    ) : (
                      <div className="user-avatar-placeholder">
                        {user?.name?.[0] || user?.email?.[0]}
                      </div>
                    )}
                  </button>
                  <div className="user-dropdown">
                    <div className="user-info">
                      <span className="user-name">{user?.name}</span>
                      <span className="user-email">{user?.email}</span>
                    </div>
                    <hr />
                    <Link to="/dashboard" className="dropdown-item">
                      Dashboard
                    </Link>
                    <Link to="/pricing" className="dropdown-item">
                      Buy Credits
                    </Link>
                    <hr />
                    <button onClick={handleLogout} className="dropdown-item logout">
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <Link to="/login" className="btn btn-primary">
                Sign In
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
